// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-registration-form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    padding: 30px 16px calc(env(safe-area-inset-bottom, 0));
    box-sizing: border-box;
    z-index: 10;

    @media screen and (max-width: 680px) {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }
}

.tenant-registration-form__container {
    width: 100%;
    margin-top: auto;
    margin-bottom: auto;
}

.tenant-registration-form .tenant-registration-form__help-button {
    margin-bottom: 16px;
}

.tenant-registration-form__help-button span {
    text-transform: none;
    text-align: center;
    text-decoration: underline;
    text-decoration-color: var(--app-text-color-secondary) !important;
    color: var(--app-text-color-secondary);
    font-size: 1rem;
    font-weight: 400;
}

.tenant-registration-form__header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0 0 2rem;
}

.tenant-registration-form__header .app-logo {
    visibility: hidden;
}

@media screen and (min-width: 680px) {
    .tenant-registration-form__header .app-logo {
        visibility: visible;
    }

    .login-page__login-form-container--desktop .tenant-registration-form {
        min-height: 100vh;
        height: 100%;
        align-items: center;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .login-page__login-form-container--desktop .tenant-registration-form__container {
        max-width: 407px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TenantRegistration/components/TenantRegistrationForm/TenantRegistrationForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,uDAAuD;IACvD,sBAAsB;IACtB,WAAW;;IAEX;QACI,oBAAoB;QACpB,qBAAqB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,0BAA0B;IAC1B,iEAAiE;IACjE,sCAAsC;IACtC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,mBAAmB;QACnB,yBAAyB;QACzB,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".tenant-registration-form {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    background-color: white;\n    border-top-left-radius: 30px;\n    border-top-right-radius: 30px;\n    padding: 30px 16px calc(env(safe-area-inset-bottom, 0));\n    box-sizing: border-box;\n    z-index: 10;\n\n    @media screen and (max-width: 680px) {\n        padding-left: 1.5rem;\n        padding-right: 1.5rem;\n    }\n}\n\n.tenant-registration-form__container {\n    width: 100%;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.tenant-registration-form .tenant-registration-form__help-button {\n    margin-bottom: 16px;\n}\n\n.tenant-registration-form__help-button span {\n    text-transform: none;\n    text-align: center;\n    text-decoration: underline;\n    text-decoration-color: var(--app-text-color-secondary) !important;\n    color: var(--app-text-color-secondary);\n    font-size: 1rem;\n    font-weight: 400;\n}\n\n.tenant-registration-form__header {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding: 0 0 2rem;\n}\n\n.tenant-registration-form__header .app-logo {\n    visibility: hidden;\n}\n\n@media screen and (min-width: 680px) {\n    .tenant-registration-form__header .app-logo {\n        visibility: visible;\n    }\n\n    .login-page__login-form-container--desktop .tenant-registration-form {\n        min-height: 100vh;\n        height: 100%;\n        align-items: center;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n    }\n\n    .login-page__login-form-container--desktop .tenant-registration-form__container {\n        max-width: 407px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
